import React from 'react';
import Layout from '../Layout/Layout';
import Whatsapp from '../components/Whatsapp/Whatsapp';
import { useAuth } from '../hooks/AuthContext';
import { useNavigation } from '../hooks/useNavigation';

const WhatsappContainer = () => {
    const { user, logout, authToken, setUser } = useAuth();
    const navigation = useNavigation();

    const handleSavePhoneNumber = async (newPhone) => {
        const updateResponse = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/user`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
            body: JSON.stringify({ ...user, phone: newPhone }),
        });
        const updatedUser = await updateResponse.json();
        setUser(updatedUser.user);
        window.sessionStorage.setItem('user', JSON.stringify(updatedUser.user));
    }

    return (
        <Layout
            logout={logout}
            {...navigation}
        >
            <Whatsapp
                handleSavePhoneNumber={handleSavePhoneNumber}
            />
        </Layout>
    );
};

export default WhatsappContainer;
